import HttpClient from './http-client';
import URL from './url';

export default class MeritApi { 
    static getStudentMerits(payload = {}) {
        let params = [];
        Object.keys(payload).forEach(key => {
            if (payload[key]) params.push(`${key}=${payload[key]}`);
        });
        let url = params.length ? `${URL.GET_STUDENT_MERITS}?${params.join('&')}` : URL.GET_STUDENT_MERITS;
        return HttpClient.get(URL.BASE_URL + url, payload);
    }

    static getStudentMeritHistory(payload = {}) {
        let params = [];
        Object.keys(payload).forEach(key => {
            if (payload[key]) params.push(`${key}=${payload[key]}`);
        });
        let url = params.length ? `${URL.GET_STUDENT_MERIT_HISTORY}?${params.join('&')}` : URL.GET_STUDENT_MERIT_HISTORY;
        return HttpClient.get(URL.BASE_URL + url, payload);
    }

    static getStudentMeritLeaderboard(payload = {}) {
        let params = [];
        Object.keys(payload).forEach(key => {
            if (payload.hasOwnProperty(key) && payload[key] !== undefined && payload[key] !== null && payload[key] !== '') {
                params.push(`${key}=${encodeURIComponent(payload[key])}`);
            }
        });
        let url = params.length ? `${URL.GET_STUDENT_MERIT_LEADERBOARD}?${params.join('&')}` : URL.GET_STUDENT_MERIT_LEADERBOARD;
        return HttpClient.get(URL.BASE_URL + url, payload);
    }
}
